// extracted by mini-css-extract-plugin
export var banner = "InviteYourFriendsBannerDesktop-module__banner___fGz1A";
export var texture = "InviteYourFriendsBannerDesktop-module__texture___Nx6gW";
export var content = "InviteYourFriendsBannerDesktop-module__content___xdRmX";
export var iconAndText = "InviteYourFriendsBannerDesktop-module__iconAndText___UGqPC";
export var title = "InviteYourFriendsBannerDesktop-module__title___xKWQc";
export var subtitle = "InviteYourFriendsBannerDesktop-module__subtitle___n5NBH";